import { Box, Modal, Stack } from '@mui/material';

import { ModalRegisterContentSx } from '@/components/content/Cart/parts/ModalRegister/styles/main';
import { Register } from '@/components/content/Register';

interface ModalRegisterProps {
	onClose: () => void;
	onGoBack: () => void;
}

export const ModalRegister: React.FC<ModalRegisterProps> = ({ onGoBack, onClose }) => (
	<Modal
		open
		sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		}}
	>
		<Box>
			<Stack sx={ModalRegisterContentSx}>
				<Register
					id={''}
					withoutLogin
					shouldCallToModal
					onGoBack={onGoBack}
					onClose={onClose}
					origin="cart"
				/>
			</Stack>
		</Box>
	</Modal>
);
